import { TranslateService } from '@ngx-translate/core';

export const HtmlEditorStyle = `
p {
  margin: 0;
}
.ProseMirror-trailingBreak {
  display: none;
}`;

export class HtmlBuilder extends Array<string> {
  readonly noMargin = 'margin: 0;';
  readonly listPadding = 'padding-left: 1rem;';
  readonly decimalList = 'list-style-type: decimal;';
  readonly discList = 'list-style-type: disc;';
  readonly menu1 =
    'font-weight: 700; line-height: 1.5rem; letter-spacing: 0.4px;';
  readonly body2 =
    'font-family: Roboto, sans-serif; font-size: 0.875rem; line-height: 1.3125rem; letter-spacing: 0.35px;';
  readonly neutral70 = 'color: #676D70;';

  constructor(protected readonly translate: TranslateService) {
    super();
  }

  title(title: string): this {
    this.push(this.tag('p', title, this.noMargin, this.menu1));
    return this;
  }

  paragraph(content: string, ...styles: string[]): this {
    this.push(this.tag('p', content, this.noMargin, ...styles));
    return this;
  }

  breakLine(): this {
    this.push('<br>');
    return this;
  }

  numberedList(items: string[], ...styles: string[]): this {
    this.push(
      this.list(
        'ol',
        items,
        this.decimalList,
        this.noMargin,
        this.listPadding,
        ...styles,
      ),
    );
    return this;
  }

  bulletList(items: string[], ...styles: string[]): this {
    this.push(
      this.list(
        'ul',
        items,
        this.discList,
        this.noMargin,
        this.listPadding,
        ...styles,
      ),
    );
    return this;
  }

  build(): string {
    return this.tag('div', this.join(''), this.body2);
  }

  tag(tag: string, content: string, ...styles: string[]): string {
    const styleAttribute = styles?.length ? ` style="${styles.join(' ')}"` : '';
    return `<${tag}${styleAttribute}>${content}</${tag}>`;
  }

  list(tag: string, items: string[], ...styles: string[]): string {
    return this.tag(
      tag,
      items.map((item) => this.tag('li', item)).join(''),
      ...styles,
    );
  }
}
